import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartYourTransition from "./sections/StartYourTransition";
import PrivateConsultation from "./sections/PrivateConsultation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartYourTransition />
      <PrivateConsultation />
      <Footer />
    </div>;
}